<div class="card-info" *ngIf="flashPaymentService.controller.isCard">
    <div class="summary-container" *ngIf="!flashPaymentService.controller.canOpenAthPinPad">
      <div class="summary-title-info">
        <div
            class="summary-title"
             *ngIf="flashPaymentService.controller.transactionType === 'INVOICE PAYMENTS'"
        >
          Pago de Factura
        </div>
        <div
          class="summary-title"
          *ngIf="flashPaymentService.controller.transactionType === 'PREPAID PRODUCT RECHARGES'"
        >
          Recarga Prepago
        </div>
        <div
          class="summary-title"
          *ngIf="flashPaymentService.controller.transactionType === 'INSTALLMENT ACCELERATION'"
        >
          Aceleraci&oacute;n de Installment
        </div>
        <div class="summary-title">{{flashPaymentService.controller.today.toString().substring(0,10) | date: 'MM/dd/yyyy'}}</div>
      </div>

      <!-- <div class="summary-items">
        <div class="title-item">N&uacute;mero de Orden</div>
        <div class="value-item">{{flashPaymentService.numberOfOrder}}</div>
      </div> -->

      <div class="summary-items">
        <div class="title-item">N&uacute;mero de Cuenta</div>
        <div class="value-item">{{flashPaymentService.controller.accountNumber}}</div>
      </div>

      <div class="summary-items">
        <div class="title-item">N&uacute;mero de Tarjeta</div>
        <div class="value-item">{{flashPaymentService.controller.cardNumberString}}</div>
      </div>

      <div class="summary-items">
        <div class="title-item">Fecha de Expiraci&oacute;n</div>
        <div class="value-item">{{flashPaymentService.controller.expirationDate | date: 'MM/dd/yyyy'}}</div>
      </div>

      <div class="line-decorator-strong"></div>
      <div class="action-container"><strong>Total a pagar</strong></div>
      <div class="action-container">
        <div class="amount-to-pay">{{flashPaymentService.controller.operationAmount | currency}}</div>
      </div>
    </div>

    <div class="action-container" *ngIf="!flashPaymentService.controller.canOpenAthPinPad">
      <button
      (click)="flashPaymentService.stepUpdate(2)"
       class="btn btn-danger action-btn" [disabled]="flashPaymentService.controller.disabledBtn">
        &nbsp; &nbsp; &nbsp; Pagar &nbsp; &nbsp; &nbsp;
      </button>
    </div>

    <app-ath-pinpad></app-ath-pinpad>
  </div>
